// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"504fe300","458":"fd313169","591":"044127eb","605":"5eca164a","700":"c789bfcc","840":"8c012ff4","946":"1301c922"}[chunkId] + ".chunk.js";
};